// extracted by mini-css-extract-plugin
export default {"pageNotFound":"PageNotFound_pageNotFound__iOpE7","pageNotFound__box":"PageNotFound_pageNotFound__box__YWjpS","pageNotFound__footer":"PageNotFound_pageNotFound__footer__rv-KM"};